/**
 * Store for opening the MetaInfo manager dialog from anywhere in the app
 * (e.g. the Object Explorer database context menu) without prop drilling.
 */

import { create } from 'zustand';

type MetaInfoManagerDialogState = {
  isOpen: boolean;
  connectionId: string;
  database: string;
};

type MetaInfoManagerDialogActions = {
  openDialog: (params: { connectionId: string; database: string }) => void;
  closeDialog: () => void;
};

type MetaInfoManagerDialogStore = MetaInfoManagerDialogState & MetaInfoManagerDialogActions;

const initialState: MetaInfoManagerDialogState = {
  isOpen: false,
  connectionId: '',
  database: '',
};

export const useMetaInfoManagerDialogStore = create<MetaInfoManagerDialogStore>((set) => ({
  ...initialState,
  openDialog: (params) =>
    set({
      isOpen: true,
      connectionId: params.connectionId,
      database: params.database,
    }),
  closeDialog: () => set({ isOpen: false }),
}));
